import "./application.css";
import { mount } from "svelte";
import AppShell from "../components/AppShell.svelte";

document.querySelectorAll("[data-svelte-app-shell]").forEach((target) => {
  const isAdmin = target.dataset.currentUserAdmin === "true";
  const userEmail = target.dataset.currentUserEmail || "";
  const userRole = target.dataset.currentUserRole || "";

  mount(AppShell, {
    target,
    props: { isAdmin, userEmail, userRole }
  });
});
